var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8191 7.18306C24.0603 7.42714 24.0603 7.82286 23.8191 8.06694L10.2309 21.8169C9.98965 22.061 9.59858 22.061 9.35738 21.8169L3.1809 15.5669C2.9397 15.3229 2.9397 14.9271 3.1809 14.6831C3.42211 14.439 3.81318 14.439 4.05439 14.6831L9.79412 20.4911L22.9456 7.18306C23.1868 6.93898 23.5779 6.93898 23.8191 7.18306Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.f7afd13e.svg";
export { ForwardRef as ReactComponent };